<script>
import vue2Dropzone from 'vue2-dropzone';
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Merchandising from '../../../services/Merchandising';
import Swal from 'sweetalert2';

export default {
  name: 'ModalProductImageUpload',
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    productId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      productImage: null,
      isBusy: false,
      dropzoneOptions: {
        url: '#',
        thumbnailWidth: 150,
        maxFilesize: 5,
        maxFiles: 1,
        acceptedFiles: '.jpg,.jpeg,.png,.gif,.bmp,.webp',
        addRemoveLinks: true,
        dictDefaultMessage: 'Drop image file here or click to upload.',
        dictRemoveFile: 'Remove',
        dictCancelUpload: 'Cancel',
        dictUploadCanceled: 'Upload canceled.',
        dictInvalidFileType: 'Invalid file type. Only images are allowed.',
        dictFileTooBig: 'File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.',
        dictMaxFilesExceeded: 'You can not upload any more files.',
      }
    };
  },
  methods: {
    selectFileProductImage(files) {
      if (files.length > 0) {
        this.productImage = files[0];
      }
    },

    async uploadProductImage() {
      if (!this.productImage) {
        this.$toast.error('Please select an image file');
        return;
      }

      try {
        this.isBusy = true;
        
        const formData = new FormData();
        formData.append('product_id', this.productId);
        formData.append('image', this.cle);

        // const response = await Merchandising.uploadProductImage(formData);
        const response = await Merchandising.uploadProductImageMerch(formData);

        if (response && response.data && response.data.success) {
          this.successmsg('Image uploaded successfully!');
          this.$emit('uploaded', response.data.data);
          this.resetUploadForm();
          this.$emit('close');
        } else {
          this.failedmsg(response?.data?.error || 'Failed to upload product image');
        }
        
      } catch (error) {
        console.error('Error uploading product image:', error);
        this.failedmsg(error.response?.data?.error || 'Failed to upload product image');
      } finally {
        this.isBusy = false;
      }
    },

    successmsg(message = 'Operation completed successfully!') {
      Swal.fire({
        position: "center",
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 2000,
      });
    },

    failedmsg(msg) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },

    resetUploadForm() {
      // Clear the dropzone
      if (this.$refs.myVueDropzone_product_image) {
        this.$refs.myVueDropzone_product_image.removeAllFiles();
      }
      this.productImage = null;
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.resetUploadForm();
      }
    }
  }
};
</script>
<template>
  <b-modal 
    :visible="visible" 
    title="Upload Product Image"
    size="lg"
    centered
    @hidden="$emit('close')"
  >
    <div class="card-body">
      <div class="form-group">
        <label for="product_image">Product Image:</label>
        <template>
          <vueDropzone
              id="product_image"
              ref="myVueDropzone_product_image"
              :use-custom-slot="true"
              :options="dropzoneOptions"
              @vdropzone-files-added="selectFileProductImage"
              no-progress-bar
          >
            <div class="dropzone-custom-content">
              <i class="display-4 text-muted bx bxs-cloud-upload"></i>
              <h4>Drop image file here or click to upload.</h4>
              <p class="text-muted">Max file size: 5MB</p>
            </div>
          </vueDropzone>
        </template>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <button 
          type="button" 
          class="btn btn-secondary" 
          @click="$emit('close')"
        >
          Cancel
        </button>
        <button 
          @click="uploadProductImage" 
          :disabled="!productImage || isBusy"
          class="btn btn-primary"
        >
          <div v-if="isBusy" class="spinner-border spinner-border-sm me-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          Upload Image
        </button>
      </div>
    </template>
  </b-modal>
</template>



<style scoped>
.dropzone-custom-content {
  text-align: center;
  padding: 40px 20px;
}

.dropzone-custom-content i {
  color: #6c757d;
  margin-bottom: 20px;
}

.dropzone-custom-content h4 {
  color: #495057;
  margin-bottom: 10px;
}

.dropzone-custom-content p {
  margin: 0;
}
</style>
